// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg-color: #f0f2f5;
  --card-bg: #ffffff;
  --text-color: #333333;
  --header-bg: #007bff;
  --header-text: #ffffff;
  --btn-primary: #007bff;
  --border-color: #e0e0e0;
}

/* Dark Mode Overrides */
.dark {
  --bg-color: #121212;
  --card-bg: #1e1e1e;
  --text-color: #e0e0e0;
  --header-bg: #333333;
  --header-text: #e0e0e0;
  --btn-primary: #4dabf7;
  --border-color: #444444;
}

/* Base Styles for the whole container */
.container {
  background-color: var(--bg-color);
  color: var(--text-color);
  transition: all 0.3s ease;
}

/* Ensure Cards inherit the theme */
.card {
  background-color: var(--card-bg);
  color: var(--text-color);
  transition: background-color 0.3s, color 0.3s;
}

/* Buttons */
.btn {
  color: var(--text-color);
  background-color: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.15s, background-color 0.15s;
}
.btn:hover {
  opacity: 0.85;
}
.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.btn-primary {
  background-color: var(--btn-primary);
  color: white;
  border-color: var(--btn-primary);
}

@keyframes trivia-wrong-shake {
  0%, 100% { transform: translateX(0); }
  20% { transform: translateX(-6px); }
  40% { transform: translateX(6px); }
  60% { transform: translateX(-4px); }
  80% { transform: translateX(4px); }
}

@keyframes trivia-correct-bounce {
  0% { transform: scale(1); filter: hue-rotate(0deg) saturate(1.1); }
  25% { transform: scale(1.08); filter: hue-rotate(140deg) saturate(1.4); }
  55% { transform: scale(0.96); filter: hue-rotate(280deg) saturate(1.6); }
  100% { transform: scale(1); filter: hue-rotate(360deg) saturate(1.1); }
}

@keyframes trivia-star-burst {
  0% { transform: translate(0, 0) scale(0.5) rotate(0deg); opacity: 0; }
  15% { opacity: 1; }
  100% { transform: translate(var(--dx), var(--dy)) scale(1.35) rotate(25deg); opacity: 0; }
}

.trivia-answer-btn.animations-on:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.14);
}

.trivia-answer-btn.animations-on:active:not(:disabled) {
  transform: scale(0.97);
}

.trivia-answer-btn.animations-on.answer-wrong {
  animation: trivia-wrong-shake 0.45s ease;
}

.trivia-answer-btn.animations-on.answer-correct {
  animation: trivia-correct-bounce 0.42s linear;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.35), 0 0 22px rgba(255, 223, 90, 0.8);
}

.answer-star-burst {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.answer-star {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  opacity: 0;
  animation: trivia-star-burst 0.55s ease-out forwards;
}

.answer-star-1 { --dx: -60px; --dy: -48px; animation-delay: 0s; }
.answer-star-2 { --dx: 0px; --dy: -72px; animation-delay: 0.03s; }
.answer-star-3 { --dx: 62px; --dy: -40px; animation-delay: 0.06s; }
.answer-star-4 { --dx: -52px; --dy: 32px; animation-delay: 0.02s; }
.answer-star-5 { --dx: 8px; --dy: 68px; animation-delay: 0.08s; }
.answer-star-6 { --dx: 66px; --dy: 28px; animation-delay: 0.04s; }

.trivia-answer-btn.animations-off .answer-star-burst {
  display: none;
}

.table-scroll {
  overflow-x: auto;
}

.leaderboard-table th,
.leaderboard-table td {
  white-space: nowrap;
}

@media (max-width: 720px) {
  .app-shell {
    padding: 12px !important;
  }

  .app-header {
    padding: 16px !important;
    border-radius: 10px 10px 0 0;
  }

  .app-header-actions {
    width: 100%;
    justify-content: space-between;
  }

  .app-nav {
    gap: 12px !important;
  }

  .leaderboard-table th,
  .leaderboard-table td {
    padding: 6px !important;
    font-size: 12px;
  }
}

/* ── SharePlay responsive layout ──────────────────────────────────────────── */
.sp-grid {
  display: grid;
  grid-template-columns: 200px 1fr 220px;
  gap: 14px;
}
.sp-players { order: 0; }
.sp-center  { order: 0; }
.sp-right   { order: 0; }
.sp-scoring { order: 0; }
.sp-actions-wrap { order: 0; grid-column: 1 / -1; }

.sp-tv-grid {
  display: grid;
  grid-template-columns: 1fr 280px;
  gap: 20px;
}
.sp-tv-center { order: 0; }
.sp-tv-right  { order: 0; }

.sp-lobby {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

@media (max-width: 720px) {
  .sp-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  .sp-right       { order: 1; }
  .sp-center      { order: 2; }
  .sp-actions-wrap { order: 3; }
  .sp-players     { order: 4; }
  .sp-scoring     { order: 5; }

  .sp-tv-grid {
    grid-template-columns: 1fr;
    gap: 14px;
  }
  .sp-tv-center { order: 1; }
  .sp-tv-right  { order: 2; }

  .sp-lobby {
    grid-template-columns: 1fr;
    gap: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,wCAAwC;AACxC;EACE,iCAAiC;EACjC,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,gCAAgC;EAChC,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA,YAAY;AACZ;EACE,wBAAwB;EACxB,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,iDAAiD;AACnD;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;EAClC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;AACpC;;AAEA;EACE,KAAK,mBAAmB,EAAE,sCAAsC,EAAE;EAClE,MAAM,sBAAsB,EAAE,wCAAwC,EAAE;EACxE,MAAM,sBAAsB,EAAE,wCAAwC,EAAE;EACxE,OAAO,mBAAmB,EAAE,wCAAwC,EAAE;AACxE;;AAEA;EACE,KAAK,kDAAkD,EAAE,UAAU,EAAE;EACrE,MAAM,UAAU,EAAE;EAClB,OAAO,oEAAoE,EAAE,UAAU,EAAE;AAC3F;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,6CAA6C;EAC7C,iFAAiF;AACnF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,eAAe;EACf,UAAU;EACV,oDAAoD;AACtD;;AAEA,iBAAiB,WAAW,EAAE,WAAW,EAAE,mBAAmB,EAAE;AAChE,iBAAiB,SAAS,EAAE,WAAW,EAAE,sBAAsB,EAAE;AACjE,iBAAiB,UAAU,EAAE,WAAW,EAAE,sBAAsB,EAAE;AAClE,iBAAiB,WAAW,EAAE,UAAU,EAAE,sBAAsB,EAAE;AAClE,iBAAiB,SAAS,EAAE,UAAU,EAAE,sBAAsB,EAAE;AAChE,iBAAiB,UAAU,EAAE,UAAU,EAAE,sBAAsB,EAAE;;AAEjE;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;IAEE,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;AACX;AACA,cAAc,QAAQ,EAAE;AACxB,cAAc,QAAQ,EAAE;AACxB,cAAc,QAAQ,EAAE;AACxB,cAAc,QAAQ,EAAE;AACxB,mBAAmB,QAAQ,EAAE,mBAAmB,EAAE;;AAElD;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;AACA,gBAAgB,QAAQ,EAAE;AAC1B,gBAAgB,QAAQ,EAAE;;AAE1B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA,kBAAkB,QAAQ,EAAE;EAC5B,kBAAkB,QAAQ,EAAE;EAC5B,mBAAmB,QAAQ,EAAE;EAC7B,kBAAkB,QAAQ,EAAE;EAC5B,kBAAkB,QAAQ,EAAE;;EAE5B;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA,gBAAgB,QAAQ,EAAE;EAC1B,gBAAgB,QAAQ,EAAE;;EAE1B;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF","sourcesContent":[":root {\r\n  --bg-color: #f0f2f5;\r\n  --card-bg: #ffffff;\r\n  --text-color: #333333;\r\n  --header-bg: #007bff;\r\n  --header-text: #ffffff;\r\n  --btn-primary: #007bff;\r\n  --border-color: #e0e0e0;\r\n}\r\n\r\n/* Dark Mode Overrides */\r\n.dark {\r\n  --bg-color: #121212;\r\n  --card-bg: #1e1e1e;\r\n  --text-color: #e0e0e0;\r\n  --header-bg: #333333;\r\n  --header-text: #e0e0e0;\r\n  --btn-primary: #4dabf7;\r\n  --border-color: #444444;\r\n}\r\n\r\n/* Base Styles for the whole container */\r\n.container {\r\n  background-color: var(--bg-color);\r\n  color: var(--text-color);\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n/* Ensure Cards inherit the theme */\r\n.card {\r\n  background-color: var(--card-bg);\r\n  color: var(--text-color);\r\n  transition: background-color 0.3s, color 0.3s;\r\n}\r\n\r\n/* Buttons */\r\n.btn {\r\n  color: var(--text-color);\r\n  background-color: var(--card-bg);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: opacity 0.15s, background-color 0.15s;\r\n}\r\n.btn:hover {\r\n  opacity: 0.85;\r\n}\r\n.btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n.btn-primary {\r\n  background-color: var(--btn-primary);\r\n  color: white;\r\n  border-color: var(--btn-primary);\r\n}\n\n@keyframes trivia-wrong-shake {\n  0%, 100% { transform: translateX(0); }\n  20% { transform: translateX(-6px); }\n  40% { transform: translateX(6px); }\n  60% { transform: translateX(-4px); }\n  80% { transform: translateX(4px); }\n}\n\n@keyframes trivia-correct-bounce {\n  0% { transform: scale(1); filter: hue-rotate(0deg) saturate(1.1); }\n  25% { transform: scale(1.08); filter: hue-rotate(140deg) saturate(1.4); }\n  55% { transform: scale(0.96); filter: hue-rotate(280deg) saturate(1.6); }\n  100% { transform: scale(1); filter: hue-rotate(360deg) saturate(1.1); }\n}\n\n@keyframes trivia-star-burst {\n  0% { transform: translate(0, 0) scale(0.5) rotate(0deg); opacity: 0; }\n  15% { opacity: 1; }\n  100% { transform: translate(var(--dx), var(--dy)) scale(1.35) rotate(25deg); opacity: 0; }\n}\n\n.trivia-answer-btn.animations-on:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.14);\n}\n\n.trivia-answer-btn.animations-on:active:not(:disabled) {\n  transform: scale(0.97);\n}\n\n.trivia-answer-btn.animations-on.answer-wrong {\n  animation: trivia-wrong-shake 0.45s ease;\n}\n\n.trivia-answer-btn.animations-on.answer-correct {\n  animation: trivia-correct-bounce 0.42s linear;\n  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.35), 0 0 22px rgba(255, 223, 90, 0.8);\n}\n\n.answer-star-burst {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n}\n\n.answer-star {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 18px;\n  opacity: 0;\n  animation: trivia-star-burst 0.55s ease-out forwards;\n}\n\n.answer-star-1 { --dx: -60px; --dy: -48px; animation-delay: 0s; }\n.answer-star-2 { --dx: 0px; --dy: -72px; animation-delay: 0.03s; }\n.answer-star-3 { --dx: 62px; --dy: -40px; animation-delay: 0.06s; }\n.answer-star-4 { --dx: -52px; --dy: 32px; animation-delay: 0.02s; }\n.answer-star-5 { --dx: 8px; --dy: 68px; animation-delay: 0.08s; }\n.answer-star-6 { --dx: 66px; --dy: 28px; animation-delay: 0.04s; }\n\n.trivia-answer-btn.animations-off .answer-star-burst {\n  display: none;\n}\n\n.table-scroll {\n  overflow-x: auto;\n}\n\n.leaderboard-table th,\n.leaderboard-table td {\n  white-space: nowrap;\n}\n\n@media (max-width: 720px) {\r\n  .app-shell {\r\n    padding: 12px !important;\r\n  }\r\n\r\n  .app-header {\r\n    padding: 16px !important;\r\n    border-radius: 10px 10px 0 0;\r\n  }\r\n\r\n  .app-header-actions {\r\n    width: 100%;\r\n    justify-content: space-between;\r\n  }\r\n\r\n  .app-nav {\r\n    gap: 12px !important;\r\n  }\r\n\r\n  .leaderboard-table th,\r\n  .leaderboard-table td {\r\n    padding: 6px !important;\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n/* ── SharePlay responsive layout ──────────────────────────────────────────── */\r\n.sp-grid {\r\n  display: grid;\r\n  grid-template-columns: 200px 1fr 220px;\r\n  gap: 14px;\r\n}\r\n.sp-players { order: 0; }\r\n.sp-center  { order: 0; }\r\n.sp-right   { order: 0; }\r\n.sp-scoring { order: 0; }\r\n.sp-actions-wrap { order: 0; grid-column: 1 / -1; }\r\n\r\n.sp-tv-grid {\r\n  display: grid;\r\n  grid-template-columns: 1fr 280px;\r\n  gap: 20px;\r\n}\r\n.sp-tv-center { order: 0; }\r\n.sp-tv-right  { order: 0; }\r\n\r\n.sp-lobby {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 20px;\r\n}\r\n\r\n@media (max-width: 720px) {\r\n  .sp-grid {\r\n    grid-template-columns: 1fr;\r\n    gap: 12px;\r\n  }\r\n  .sp-right       { order: 1; }\r\n  .sp-center      { order: 2; }\r\n  .sp-actions-wrap { order: 3; }\r\n  .sp-players     { order: 4; }\r\n  .sp-scoring     { order: 5; }\r\n\r\n  .sp-tv-grid {\r\n    grid-template-columns: 1fr;\r\n    gap: 14px;\r\n  }\r\n  .sp-tv-center { order: 1; }\r\n  .sp-tv-right  { order: 2; }\r\n\r\n  .sp-lobby {\r\n    grid-template-columns: 1fr;\r\n    gap: 14px;\r\n  }\r\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
